import Vue from 'vue';
import { UserService } from '@/services/UserService';
import { AssociationService } from '@/services/AssociationService';
import { AspNetRole, AssociationRoleEnum } from '../../models/Enums';
import SelectListItem from '../../models/SelectListItem';
import AdminRegistrationRequest from '../../models/api/user/AdminRegistrationRequest';
import UserRegistrationRequest from '../../models/api/user/UserRegistrationRequest';
import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
import { DataTableHelper } from '@/helpers/DataTableHelper';
import { SnackbarService } from '../../services/SnackbarService';

export default Vue.extend({
    components: {
        DeleteDialog
    },
    data() {
        return {
            // Table
            expanded: [],
            singleExpand: false,
            totalCount: 0,
            items: [],
            loading: true,
            options: {},
            headers: [
                {
                    text: 'name',
                    align: 'start',
                    value: 'userName',
                },
                {
                    text: 'role',
                    value: 'role'
                },
                {
                    text: 'user.emailConfirmed',
                    sortable: true,
                    value: 'emailConfirmed',
                    align: 'center',
                },
                {
                    text: '',
                    sortable: false,
                    value: 'action'
                },
            ],

            // Delete dialog
            showDelete: false,
            itemToDeleteId: "",
            itemToDeleteName: "",

            showCreate: false,

            email: "",
            roles: [new SelectListItem("", "")],
            selectedRole: "0",

            rules: {
                required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required')
            },
            users: [],
        }
    },
    created() {
        DataTableHelper.adaptTableHeaders(this.headers, this);

        this.$store.commit('addOverlay');
        UserService.GetRegisterRoles().then(response => {
            this.roles = [];
            response.data.forEach((role: AspNetRole) => { this.roles.push(new SelectListItem(this.$vuetify.lang.t('$vuetify.user.' +this.getRoleName(role)), role.toString())) });

        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            this.$store.commit('removeOverlay');
        });
       
        this.getAdminsPaged();
    },
    watch: {
        options: {
            handler() {
                this.getAdminsPaged();
            },
            deep: true,
        },
    },
    methods: {
        getAssociationRoleName(role: AssociationRoleEnum) {
            return AssociationRoleEnum[role];
        },
        getRoleName(role: AspNetRole) {
            return AspNetRole[role];
        },
        closeCreate() {
            this.clearCreateForm();
            this.showCreate = false;
        },
        clearCreateForm() {
            this.email = "";
            this.selectedRole = "0";
        },
        async getAdminsPaged() {
            this.loading = true;

            const sortBy = (this.options as any).sortBy ?? [];
            const sortDesc = (this.options as any).sortDesc ?? [];
            const page = (this.options as any).page ?? 1;
            const itemsPerPage = (this.options as any).itemsPerPage ?? 10;

            const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage };

            UserService.GetAdminsPaged(data).then(response => {
                this.totalCount = response.data.totalCount;
                this.items = response.data.items;
                this.items.forEach((s: any) => { s.canExpand = s.role == AspNetRole.AssociationUser; });

            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.loading = false;
            });
        },
        async sendConfirmEmail(email: string) {
            window.location.href.lastIndexOf("#/")
            const validateEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

            this.$store.commit('addOverlay');

            UserService.SendConfirmEmail({ email: email, emailConfirmationUrl: validateEmailUrl }).then(() => {
                SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.confirmEmailSent'));
            }).catch((error) => {
                if (error.response.data.errors) {
                    SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                } else {
                    SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                }
            }).finally(() => {
                this.$store.commit('removeOverlay');
            });
        },
        async submit() {
            window.location.href.lastIndexOf("#/")

            const validateEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

            this.$store.commit('addOverlay');

            UserService.RegisterAdmin(new AdminRegistrationRequest(this.email, parseInt(this.selectedRole as string), validateEmailUrl)).then(() => {
                this.clearCreateForm();

                SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.userCreatedMessage'));
                this.showCreate = false;
                this.getAdminsPaged();
            }).catch((error) => {
                if (error.response.data.errors) {
                    SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                } else {
                    SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                }
            }).finally(() => {
                this.$store.commit('removeOverlay');
            });
        },
        async showDeleteDialog(id: string, name: string) {
            this.itemToDeleteId = id;
            this.itemToDeleteName = name;
            this.showDelete = true;
        },
        async deleteCallback(itemToDeleteId: string) {
            this.showDelete = false;

            if (itemToDeleteId) {
                this.$store.commit('addOverlay');
                UserService.DeleteUser(this.itemToDeleteId).then(() => {
                    SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.removedMessage'));

                    this.getAdminsPaged();
                }).catch((error) => {
                    if (error.response.data.errors) {
                        SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                    } else {
                        SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                    }
                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });
            }
        }
    },
});
